import styled from 'styled-components';

import { ReadyBadge, ScheduledBadge } from 'ui/badge';
import { isDefined } from 'utils/tsHelpers';
import { Combinator } from '../../domain';
import { useClauseCombinatorWatch, useIsFirstCondition } from '../../hooks/form';
import { useIsIfClause } from '../../hooks/useIsIfClause';
import { useTranslation } from '../../hooks/useTranslation';

export const IfPrompt = styled.span`
  ${({ theme }) => theme.styles.body.body2};
  color: ${({ theme }) => theme.colors.textColors.textSecondary};
  text-align: right;
  width: ${({ theme }) => theme.spacing.utils.pxToRem(44)};
  padding-top: ${({ theme }) => theme.spacing.utils.pxToRem(8)};
  white-space: nowrap;
`;

export const StyledScheduledBadge = styled(ScheduledBadge)`
  height: fit-content;
  margin-top: ${({ theme }) => theme.spacing.values.threeEights};
`;

export const StyledReadyBadge = styled(ReadyBadge)`
  height: fit-content;
  margin-top: ${({ theme }) => theme.spacing.values.threeEights};
`;

export const DATA_TEST = {
  prompt: 'prompt',
};

export const Prompt = () => {
  const combinator = useClauseCombinatorWatch();
  const { t } = useTranslation();

  const isFirstCondition = useIsFirstCondition();
  const isIfClause = useIsIfClause();

  const CombinatorBadge = combinator === Combinator.AND ? StyledScheduledBadge : StyledReadyBadge;
  const label = isIfClause ? t('prompt.if') : t('prompt.elseIf');

  if (isDefined(combinator) && !isFirstCondition)
    return <CombinatorBadge>{combinator.toUpperCase()}</CombinatorBadge>;
  return <IfPrompt data-test={DATA_TEST.prompt}>{label}</IfPrompt>;
};
